module.exports = __webpack_public_path__ + "static/media/close.ebadc12f.svg";